export const NO_RESULT_TEXT = 'Aucun résultat';
export const PUBLISHED_AT_TEXT = 'Publié le';
export const UNKNOWN_TEXT = 'Inconnu';
